export default __webpack_public_path__ + "static/media/Nerd_YETI.9d2ad505.png";